// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsBargainStyles } from "@awc/App/Widgets/ProductDetails/ProductDetailsBargain";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productDetailsBargainStyles.mainTitle = {
    variant: "h2",
    color: "common.white",
    css: css`
        background-color: ${color("primary")};
        padding: 12px;
        margin-bottom: 0;
    `,
};

productDetailsBargainStyles.tableHeadText = {
    css: css`
        display: block;
        text-align: left;
        white-space: pre-wrap;
    `,
};

productDetailsBargainStyles.dataCellsHead = {
    mergeCss: true,
    css: css`
        border: none;
        ${TypographyStyle} {
            font-weight: ${fontConfig.weight.bold};
        }
    `,
};

productDetailsBargainStyles.dataCells = {
    mergeCss: true,
    css: css`
        border: none;
        &&& > ${TypographyStyle}:empty:after {
            content: "";
        }
    `,
};
productDetailsBargainStyles.dataHeader = {
    mergeCss: true,
    css: css`
        ${TypographyStyle} {
            max-width: unset !important;
        }
    `,
};
productDetailsBargainStyles.tableHeadText = {
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        padding: 8px 12px 8px 8px;
        background: ${color("common.border")};
        border: 1px solid ${color("common.ui22")};
        border-bottom: 0;
    `,
};

productDetailsBargainStyles.dataTable = {
    css: css`
        border: 1px solid ${color("common.ui22")};
        border-top: 0;

        tr {
            &:nth-child(even) {
                background: ${color("common.border")};
            }
        }
    `,
};
